import { Injectable } from '@angular/core';

import { SessionStorageStateType } from '../online-estimate/model/session-storage-state';

@Injectable({ providedIn: 'root' })
export class StatePersistenceService {
  persistState(
    key: string,
    value: SessionStorageStateType,
    sessionStorageKey: string,
  ): void {
    const sessionStorageValue = sessionStorage.getItem(sessionStorageKey);

    if (sessionStorageValue) {
      const state = JSON.parse(sessionStorageValue);

      state[key] = value;

      sessionStorage.removeItem(sessionStorageKey);
      sessionStorage.setItem(sessionStorageKey, JSON.stringify(state));
    } else {
      const newState = { [key]: value };
      sessionStorage.setItem(sessionStorageKey, JSON.stringify(newState));
    }
  }

  getPersistedState(
    key: string,
    fallbackValue: SessionStorageStateType,
    sessionStorageKey: string,
  ): SessionStorageStateType {
    const state = this.getPersistedStateBy(key, sessionStorageKey);

    if (state) return state;

    return fallbackValue;
  }

  getPersistedStateBy(
    key: string,
    sessionStorageKey: string,
  ): SessionStorageStateType {
    const sessionStorageValue = sessionStorage.getItem(sessionStorageKey);
    if (sessionStorageValue) {
      const state = JSON.parse(sessionStorageValue);
      return state[key] !== undefined ? state[key] : null;
    }
    return null;
  }
}
